import { useState, useEffect, useCallback } from 'react';
import { adminSupportApi } from '../store/api/adminApi';

interface SupportStats {
  open: number;
  unread: number;
}

const POLL_INTERVAL = 60_000;

export function useSupportStats(enabled = true) {
  const [stats, setStats] = useState<SupportStats>({ open: 0, unread: 0 });

  const fetch = useCallback(async () => {
    try {
      const res = await adminSupportApi.stats();
      setStats(res.data ?? { open: 0, unread: 0 });
    } catch {
      // silent — sidebar badge is non-critical
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    fetch();
    const id = setInterval(fetch, POLL_INTERVAL);
    return () => clearInterval(id);
  }, [fetch, enabled]);

  return stats;
}
